import React, { useState } from "react";
import { EMAIL, PHONE_NL, WHATSAPP_URL } from "../site/constants";
import ContentPage, { Block } from "../components/ContentPage";

export default function ContactPage() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");

  const onSubmit = (e) => {
    e.preventDefault();
    const body = [
      name && `Naam: ${name}`,
      email && `E-mail: ${email}`,
      "",
      message,
    ]
      .filter(Boolean)
      .join("\n");
    window.location.href = `mailto:${EMAIL}?subject=${encodeURIComponent(
      "Contact via website"
    )}&body=${encodeURIComponent(body)}`;
  };

  return (
    <ContentPage
      title="Contact"
      lead="Heb je een vraag over een product, bezorging of een zakelijke bestelling? Ons team helpt je graag."
      ctaLabel={null}
    >
      <Block title="Klantenservice">
        <p>
          WhatsApp:{" "}
          <a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer">
            {PHONE_NL}
          </a>
        </p>
        <p>
          E-mail: <a href={`mailto:${EMAIL}`}>{EMAIL}</a>
        </p>
        <p>Openingstijden: ma–za 09:00–18:00</p>
      </Block>

      <Block title="Stuur een bericht">
        <form className="lp-contact-form" onSubmit={onSubmit}>
          <label>
            Naam
            <input
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
            />
          </label>
          <label>
            E-mailadres
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </label>
          <label>
            Bericht
            <textarea
              rows={5}
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              required
            />
          </label>
          <button type="submit" className="lp-btn-primary">
            Verstuur bericht
          </button>
        </form>
      </Block>
    </ContentPage>
  );
}
